module.exports = __webpack_public_path__ + "static/Candy-a26123977c56fd4efd871637d687c493.png";